import { QUERY_KEYS } from '@24i/nxg-sdk-photon';
import { useQuery } from 'react-query';
import { useUserData } from '@24i/nxg-sdk-smartott-shared/src/context/UserData';
import { useAnalytics } from '@24i/nxg-sdk-smartott-shared/src/context/Analytics';

export const useEnrichedAnalytics = (originalAnalytics) => {
    const userDataClient = useUserData();
    const { attributionIDStore } = useAnalytics();
    const { data: user } = useQuery(QUERY_KEYS.user, userDataClient.fetchUser);
    const { attributionId, assetId } = attributionIDStore;
    return (trigger, payload) => {
        const newParams = { ...payload, user, attributionId, assetId };
        originalAnalytics(trigger, newParams);
    };
};
